export function $(id: string): HTMLElement {
  const node = document.getElementById(id);
  if (!node) {
    throw new Error(`Missing #${id}`);
  }
  return node;
}

export function show(node: HTMLElement): void {
  node.classList.remove("hidden");
}

export function hide(node: HTMLElement): void {
  node.classList.add("hidden");
}

export function formatLoot(gold: number, crystals: number): string {
  return `${gold} gold · ${crystals} crystals`;
}

export function formatClock(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}
